import { render, staticRenderFns } from "./epb-facets-settings-section.component.vue?vue&type=template&id=4362e61c&scoped=true"
import script from "./epb-facets-settings-section.component.vue?vue&type=script&lang=ts"
export * from "./epb-facets-settings-section.component.vue?vue&type=script&lang=ts"
import style0 from "./epb-facets-settings-section.component.vue?vue&type=style&index=0&id=4362e61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4362e61c",
  null
  
)

export default component.exports